import React from 'react'
import Layout from '../../layout/Layout/Layout'
import NavigationNew from '../../layout/Navigation/Navigation-New'
import AccountsCard from './account-cards'
import BreadCum from './bread-cum'

export default function LayoutWithAccountCard({ children, pageTitle = '', breadCumKey = '' }) {
  return (
    <Layout>
      <div className='d-flex'>
        <NavigationNew />
        <div style={{ width: '100%' }}>
          <BreadCum pageTitle={pageTitle} breadCumKey={breadCumKey} />
          <div className='d-flex'>
            <AccountsCard />
            <div style={{ width: '100%', paddingLeft: 20 }}>{children}</div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
